import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var RewindFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.73 1.82V43.32c0 .399-.2.798-.598.997-.4.2-.798.1-1.097-.2L23.096 25.164V43.12c0 .4-.2.798-.598.998-.399.2-.797.1-1.097-.2L.57 22.97c-.2-.2-.3-.5-.3-.699 0-.299.1-.498.3-.698L21.302.723c.299-.299.698-.399 1.096-.2.399.1.598.5.598.899v18.554l18.94-18.954c.298-.299.797-.399 1.096-.199.498.2.698.599.698.998Z"
  }));
});
RewindFill.displayName = 'RewindFill';
RewindFill.defaultProps = {
  'aria-label': 'RewindFill'
};
export default RewindFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/RewindFill.js
// module id = 3268
// module chunks = 11